import React from "react";
import { Box } from "@mui/material";

interface ActivityLevelIndicatorProps {
  activityLevelNumber: number;
  size?: "small" | "medium" | "large";
  testIdPrefix?: string;
}

const sizeConfig = {
  small: { height: "2.4rem", width: "2.4rem", fontSize: "1.4rem", gap: "0.8rem" },
  medium: { height: "3.2rem", width: "3.2rem", fontSize: "1.8rem", gap: "1rem" },
  large: { height: "4rem", width: "4rem", fontSize: "2.2rem", gap: "1.2rem" }
};

const ActivityLevelIndicator = ({ 
  activityLevelNumber, 
  size = "medium",
  testIdPrefix = ""
}: ActivityLevelIndicatorProps) => {
  const { height, width, fontSize, gap } = sizeConfig[size];

  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap }} data-testid={`${testIdPrefix}_activity-level-indicator`}>
      {[1, 2, 3, 4].map((level) => {
        const isLevel = level.toString() === activityLevelNumber.toString();
        return (
          <Box
            key={level}
            data-testid={`${testIdPrefix}_activity-level-${level}`}
            sx={{
              backgroundColor: isLevel ? "secondary.main" : "grey.100",
              fontSize,
              lineHeight: "160%",
              color: isLevel ? "secondary.contrastText" : "text.primary",
              height,
              width,
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: 600
            }}
          >
            {level}
          </Box>
        );
      })}
    </Box>
  );
};

export default ActivityLevelIndicator;
